import { NavLink, Outlet } from 'react-router-dom'
import { useAccount } from '@/entities/session'
import { useLogout } from '@/features/auth'
import styles from './AdminLayout.module.css'

const ADMIN_ITEMS = [
  { to: '/admin', label: 'Сводка', end: true },
  { to: '/admin/balance', label: 'Баланс' },
  { to: '/admin/companies', label: 'Компании' },
  { to: '/admin/calls', label: 'Звонки' },
  { to: '/admin/audit', label: 'Журнал' },
] as const

/** Отдельный каркас админки не запускает клиентские запросы сайдбара и верхней панели. */
export function AdminLayout() {
  const { data: account } = useAccount()
  const logout = useLogout()

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.brand}>
          <span className={styles.mark}>S</span>
          <span>
            Sellora
            <small>Суперадминка</small>
          </span>
        </div>

        <nav className={styles.nav} aria-label="Разделы админки">
          {ADMIN_ITEMS.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={'end' in item ? item.end : undefined}
              className={({ isActive }) => `${styles.navItem} ${isActive ? styles.active : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className={styles.footer}>
          <span className={styles.email}>{account?.user.email}</span>
          <NavLink className={styles.clientLink} to="/">
            В кабинет
          </NavLink>
          <button
            type="button"
            className={styles.logout}
            onClick={() => logout.mutate()}
            disabled={logout.isPending}
          >
            Выйти
          </button>
        </div>
      </aside>

      <main className={styles.main}>
        <div className={styles.content}>
          <Outlet />
        </div>
      </main>
    </div>
  )
}
